<template>
  <v-login :title="'Reset Password'">
    <template v-if="!isConfirm">
      <v-fieldset
        id="newPassword"
        v-model="newPassword"
        text="New password"
        placeholder="Must have at least 6 characters"
        type="password"
        pattern="^\S{6,}"
        :help-text="newPasswordHelper"
        is-required
      />
      <v-button
        class="mt-auto"
        size="lg"
        is-block
        @click="submit"
      >
        Reset Password
      </v-button>
    </template>
    <template v-if="isConfirm">
      <strong>
        Your Password is updated successfully!
      </strong>
      <v-button
        class="mt-auto"
        size="lg"
        is-block
        @click="toLogin"
      >
        Back to Login
      </v-button>
    </template>
  </v-login>
</template>
<script>
  import Login from "@/templates/Login";
  import Fieldset from "@/molecules/Fieldset";
  import Button from "@/atoms/Button";
  import {
    MANAGE_REMIND,
    VERIFY_CODE,
    SEND_2FA_SETUP_CODE
  } from "@/store/actions.type";
  import {SET_PASSWORD} from "../store/actions.type";
  import routes from "@/common/routes";

  export default {
    name: "TwoFactorAuth",
    components: {
      "v-login": Login,
      "v-fieldset": Fieldset,
      "v-button": Button,

    },
    data() {
      return {
        pattern: /^\S{6,}/,
        url:'',
        signature:'',
        newPassword:'',
        newPasswordHelper: '',
        isConfirm: false,
      }
    },
    computed:{

    },
    watch:{
      newPassword:{
        handler:function(val){
          this.validate();
        }
      }
    },
    mounted(){
      this.signature = this.$route.query.signature;
      this.url = this.$route.query.url
    },
    methods: {
      submit:function(){
        this.validate();
        if(this.newPasswordHelper.length === 0){
          let url = this.url+'&signature='+this.signature;
          this.$store.dispatch(SET_PASSWORD,[url,this.newPassword]).then(response => {
            this.isConfirm = true;
          }).catch(error => {
            this.$notify({
              title: 'Error:',
              text: error.data.message,
              type: 'error'
            })
          })
        }
      },
      toLogin:function(){
        this.$router.push(routes.LOGIN)
      },
      validate(){
        let pattern = /^\S{6,}/;
        const isValid = pattern.test(this.newPassword)
        if(!isValid){
          this.newPasswordHelper = 'Password must contain at least six characters without spaces';
        }else{
          this.newPasswordHelper = '';
        }
      },
    }
  };
</script>
